import Icon from "../../assets/icons/icon";
import { funnelErrorArticles } from "../../config/commUrls";
import BrandedButton, { brandedButtonTypes } from "../../utilities/inputComponents/BrandedButton";
import OutlineButton from "../../utilities/helperComponents/OutlineButton";

export const CallBlockedError = ({ handleClose }) => {
  return (
    <div className="callBlocked">
      <div style={{ display: "flex", flexDirection: "row", columnGap: "18px" }}>
        <div>
          <div
            style={{
              height: "40px",
              width: "40px",
              display: "flex",
              backgroundColor: "#F95951",
              borderRadius: "8px",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
          <span className="fontello" style={{marginTop: "-6px"}}>
            <Icon
              name="q-alert-octagon"
              size={18}
              height={22}
              color="#FFFFFF"
              strokeOptions={{
                  stroke: "#fff",
                  width: "1.5",
                  lineCap: "round",
                  lineJoin: "round",
              }}
            />
          </span>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            textAlign: "left",
          }}
        >
          <div className="blockTHeader">
            Call Blocked by Carrier</div>
          <div>
            The carrier has restricted this connection. To continue with this
            lead, click below to take the next steps for verification and
            approval through the carrier.
          </div>
        </div>
      </div>
      <div 
        style={{
          display: "flex",
          justifyContent: "end",
          alignItems: "center",
          marginTop: "20px",
          columnGap: 21.356
        }}
      >
        <div>
          <div
            className="leadTopBarButton outlineQuilityActiveButton "
            style={{ width: "120px", cursor: "pointer", margin: 0, padding: "10px 16px",  borderWidth: "2px", fontSize: "16px", fontWeight: 700, borderRadius: "6px", display: "inline" }}
            onClick={handleClose}
          >
            Not Now
          </div>
        </div>
        <div className="bulkActionFooterButton" style={{margin: 0 , borderRadius: "6px", padding: "10px 16px", height: "auto"}}
         onClick={() =>
              window.open(
                `https://funnel-help.zendesk.com/hc/en-us/articles/37675488077339-Blocked-by-Carrier-How-to-Register-Phone-Number`,
                "_blank"
              )
            }
          >
          <div
            className="bulkActionFooterIcon"
            style={{cursor: "pointer", margin: 0, display: "flex", alignItems: "center", justifyContent: "center", columnGap: "8px", lineHeight: "normal"}}
          >
            <span style={{fontSize: "16px", fontWeight: 700}}>View Solutions</span>
            <span className="fontello" style={{marginTop: "-10px", transform: "scaleY(-1)"}}>
              <Icon
                name="link-external-q"
                size={18}
                height={20}
                color="#FFFFFF"
                strokeOptions={{
                  stroke: "white",
                  width: "2",
                  lineCap: "round",
                  lineJoin: "round",
                }}
              />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export const MicPermissionError = ({ handleClose }) => {
  return (
    <div className="callBlocked">
      <div style={{ display: "flex", flexDirection: "row" }}>
        <div
          style={{
            height: "30px",
            width: "30px",
            display: "flex",
            padding: "10px",
            backgroundColor: "#F95951",
            borderRadius: "5px",
            marginRight: "10px",
          }}
        >
          <Icon
            name="q-alert-octagon"
            size={36}
            height={36}
            color="#FFFFFF"
            strokeOptions={{
              stroke: "#fff",
              width: "1.5",
              lineCap: "round",
              lineJoin: "round",
            }}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            textAlign: "left",
          }}
        >
          <div className="blockTHeader">
            Your browser has lost audio permission. Please reset your permissions in order to make a call.
            </div>
          <div> </div>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "end",
          alignItems: "center",
          marginTop: "5px",
        }}
      >
        <div>
          <div
            className="leadTopBarButton outlineQuilityActiveButton "
            style={{ width: "120px", cursor: "pointer" }}
            onClick={handleClose}
          >
            Not Now
          </div>
        </div>
        <div className="bulkActionFooterButton"
           onClick={() =>
              window.open(
                `https://www.loom.com/share/4e8b181f1b234775935db12e4bb38346`,
                "_blank"
              )
            }
         >
          <div
            className="bulkActionFooterIcon"
            style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
          >
            View Solutions
            <span className="fontello" style={{ margin: "-10px  0 0 5px ",transform: "scaleY(-1)" }}>
              <Icon
                name="link-external-q"
                size={20}
                color="#FFFFFF"
                strokeOptions={{
                  stroke: "white",
                  width: "2",
                  lineCap: "round",
                  lineJoin: "round",
                }}
              />
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export const MicPermissionErrorModal = ({ handleClose }) => {
  return (
    <div className="tMobileErrorModal">
      <div className="tMobileErrorDialog">
      <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between",
        alignItems: "center"
       }}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            textAlign: "left",
          }}
        >
          <div
            style={{
              height: "30px",
              width: "30px",
              display: "flex",
              padding: "10px",
              backgroundColor: "#F95951",
              borderRadius: "5px",
            }}
          >
            <Icon
              name="q-alert-octagon"
              size={36}
              height={36}
              color="#FFFFFF"
              strokeOptions={{
                stroke: "#fff",
                width: "1.5",
                lineCap: "round",
                lineJoin: "round",
              }}
            />
          </div>
          <div
            style={{
              width: "90%",
              padding: "1rem",
              fontSize: "26px",
              fontWeight: "700",
            }}
          >
            Your browser has lost audio permission. Please reset your permissions in order to make a call.
          </div>
          <div className="closeError" onClick={handleClose}>
          <Icon
              name="T-mobile-dialog-close"
              size={20}
              strokeOptions={{
                stroke: "#707070",
                width: "2",
                lineCap: "round",
                lineJoin: "round",
              }}
            />
          </div>
        </div>

      </div>

        <div style={{ fontSize: "14px", fontWeight: "400", textAlign: "left" }}>
          The carrier has restricted this connection. To continue with this
          lead, click below to take the next steps for verification and approval
          through the carrier.
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginTop: "2rem",
            justifyContent: "space-between",
          }}
        >
          <div>
            <div
              className="leadTopBarButton outlineQuilityActiveButton "
              style={{ width: "200px", cursor: "pointer" }}
              onClick={handleClose}
            >
              Proceed with Dial Session
            </div>
          </div>
          <div className="bulkActionFooterButton"
           onClick={() =>
                window.open(
                  `https://www.loom.com/share/4e8b181f1b234775935db12e4bb38346`,
                  "_blank"
                )
              }
           >
            <div
              className="bulkActionFooterIcon"
              style={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
              }}
            >
              View Solutions
              <span className="fontello" style={{ margin: "5px 0 0 5px",transform: "scaleY(-1)", marginTop: "-18px" }}>
                <Icon
                  name="link-external-q"
                  size={20}
                  color="#FFFFFF"
                  strokeOptions={{
                    stroke: "white",
                    width: "2",
                    lineCap: "round",
                    lineJoin: "round",
                  }}
                />
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const CallBlockedErrorModal = ({ handleClose }) => {
  return (
    <div className="tMobileErrorModal">
      <div className="tMobileErrorDialog">
        <div style={{display: "flex", flexDirection: "column", rowGap: "16px"}}>
          <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between",
            alignItems: "center"
           }}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                textAlign: "left",
                  columnGap: "18px"
              }}
            >
              <div>
                <div
                  style={{
                    height: "40px",
                    width: "40px",
                    display: "flex",
                    backgroundColor: "#F95951",
                    borderRadius: "8px",
                    justifyContent: "center",
                    alignItems: "center"
                  }}
                >
                <span className="fontello" style={{marginTop: "-6px"}}>
                  <Icon
                    name="q-alert-octagon"
                    size={18}
                    height={22}
                    color="#FFFFFF"
                    strokeOptions={{
                        stroke: "#fff",
                        width: "1.5",
                        lineCap: "round",
                        lineJoin: "round",
                    }}
                  />
                </span>
                </div>
              </div>
              <div
                style={{
                  width: "90%",
                  //padding: "1rem",
                  fontSize: "26px",
                  fontWeight: "700",
                }}
          > Call Blocked by Carrier </div>
              <div className="closeError" onClick={handleClose}>
              <Icon
                  name="T-mobile-dialog-close"
                  size={20}
                  strokeOptions={{
                    stroke: "#707070",
                    width: "2",
                    lineCap: "round",
                    lineJoin: "round",
                  }}
                />
              </div>
            </div>
        {/* <div style={{ padding: "5px", cursor:'pointer',
            fontSize: '22px' }}  onClick={handleClose} >
            x
          </div>*/}
          </div>
          <div style={{ fontSize: "14px", fontWeight: "400", textAlign: "left" }}>
            The carrier has restricted this connection. To continue with this
            lead, click below to take the next steps for verification and approval
            through the carrier.
          </div>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginTop: "2rem",
            justifyContent: "space-between",
          }}
        >
          <div>
            <div
              className="leadTopBarButton outlineQuilityActiveButton "
              style={{ width: "200px", cursor: "pointer", margin: 0, padding: "10px 16px",  borderWidth: "2px", fontSize: "16px", fontWeight: 700, borderRadius: "6px", display: "inline" }}
              onClick={handleClose}
            >
              Proceed with Dial Session
            </div>
          </div>
          <div className="bulkActionFooterButton" style={{margin: 0, borderRadius: "6px", padding: "10px 16px", height: "auto"}}
           onClick={() =>
                window.open(
                  `https://funnel-help.zendesk.com/hc/en-us/articles/37675488077339-Blocked-by-Carrier-How-to-Register-Phone-Number`,
                  "_blank"
                )
              }
           >
            <div
              className="bulkActionFooterIcon"
              style={{cursor: "pointer", margin: 0, display: "flex", alignItems: "center", justifyContent: "center", columnGap: "8px", lineHeight: "normal"}}
            >
              <span style={{fontSize: "16px", fontWeight: 700}}>View Solutions</span>
              <span className="fontello" style={{marginTop: "-10px", transform: "scaleY(-1)"}}>
                <Icon
                  name="link-external-q"
                  size={18}
                  height={20}
                  color="#FFFFFF"
                  strokeOptions={{
                    stroke: "white",
                    width: "2",
                    lineCap: "round",
                    lineJoin: "round",
                  }}
                />
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const InvalidNumberErrorMsg = ({ handleClose }) => {
  return (
    <div className="callBlocked">
      <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between",
        alignItems: "center"
       }}>
      <div style={{ display: "flex", flexDirection: "row" }}>
        <div
          style={{
            height: "30px",
            width: "30px",
            display: "flex",
            padding: "10px",
            backgroundColor: "#F95951",
            borderRadius: "5px",
            marginRight: "10px",
          }}
        >
          <Icon
            name="q-alert-octagon"
            size={36}
            height={36}
            color="#FFFFFF"
            strokeOptions={{
              stroke: "#fff",
              width: "1.5",
              lineCap: "round",
              lineJoin: "round",
            }}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            textAlign: "left",
          }}
        >
          <div className="blockTHeader">Invalid Number</div>
          <div>
          This number is invalid or outside the supported region.
          </div>
        </div>
      </div>
      <div style={{ padding: "5px", marginRight: '5%', cursor:'pointer',
        fontSize: '22px' }}  onClick={handleClose} >
        x
      </div>

      </div>

    </div>
  );
};

export const InvalidNumberErrorModal = ({ handleClose }) => {
  return (
    <div className="tMobileErrorModal">
      <div className="tMobileErrorDialog">
      <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between",
        alignItems: "center"
       }}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            textAlign: "left",
          }}
        >
          <div
            style={{
              height: "30px",
              width: "30px",
              display: "flex",
              padding: "10px",
              backgroundColor: "#F95951",
              borderRadius: "5px",
            }}
          >
            <Icon
              name="q-alert-octagon"
              size={36}
              height={36}
              color="#FFFFFF"
              strokeOptions={{
                stroke: "#fff",
                width: "1.5",
                lineCap: "round",
                lineJoin: "round",
              }}
            />
          </div>
          <div
            style={{
              width: "90%",
              padding: "1rem",
              fontSize: "26px",
              fontWeight: "700",
            }}
          >
           Invalid Number
          </div>
          <div className="closeError" onClick={handleClose}>
          <Icon
              name="T-mobile-dialog-close"
              size={20}
              strokeOptions={{
                stroke: "#707070",
                width: "2",
                lineCap: "round",
                lineJoin: "round",
              }}
            />
          </div>
        </div>

        <div style={{ padding: "5px", cursor:'pointer',
        fontSize: '22px' }}  onClick={handleClose} >
        x
      </div>

      </div>

        <div style={{ fontSize: "14px", fontWeight: "400", textAlign: "left" }}>
        This number is invalid or outside the supported region.
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginTop: "2rem",
            justifyContent: "end",
          }}
        >
          <div className="bulkActionFooterButton" onClick={handleClose}>
            <div
              className="bulkActionFooterIcon"
              style={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
              }}
            >
             Proceed with Dial Session
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const IncompletePhoneErrorModal = ({ handleClose }) => {
  return (
    <div className="tMobileErrorModal">
      <div className="tMobileErrorDialog">
        <div style={{color : '#000'}}>
          <div style={{ display: "flex", flexDirection: "row", columnGap: "18px" }}>
            <div>
              <div
                style={{
                  height: "40px",
                  width: "40px",
                  display: "flex",
                  backgroundColor: "#F95951",
                  borderRadius: "8px",
                  justifyContent: "center",
                  alignItems: "center"
                }}
              >
                <span className="fontello" style={{ marginTop: "-6px" }}>
                  <Icon
                    name="q-alert-octagon"
                    size={18}
                    height={22}
                    color="#FFFFFF"
                    strokeOptions={{
                      stroke: "#fff",
                      width: "1.5",
                      lineCap: "round",
                      lineJoin: "round"
                    }}
                  />
                </span>
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                textAlign: "left"
              }}
            >
              <div className="blockTHeader">Missing or Invalid Phone Number</div>
              <div style={{marginTop : '10px' , lineHeight : '1.4'}}>
                One or more selected leads have missing or invalid phone numbers.
                Please verify that each lead has a valid 10-digit phone number before dialing.
              </div>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
              marginTop: "20px",
              columnGap: 21.356
            }}
          >
            <div>
              <div
                className="leadTopBarButton outlineQuilityActiveButton"
                style={{
                  width: "120px",
                  cursor: "pointer",
                  margin: 0,
                  marginBottom : '20px !important',
                  padding: "10px 16px",
                  borderWidth: "2px",
                  fontSize: "16px",
                  fontWeight: 700,
                  borderRadius: "6px",
                  display: "inline",
                }}
                onClick={handleClose}
              >
                Got It
              </div>
            </div>
          </div>
         </div>
      </div>
    </div>
  );
};
export const TwilioCallErrorMessage = ({ handleClose, errorMessage, errorSolutions = [] }) => {
    return (
    <div className="callBlocked">
        <div style={{ display: "flex", flexDirection: "row", columnGap: "18px" }}>
            <div>
                <div style={{ height: "40px", width: "40px", display: "flex", backgroundColor: "#F95951", borderRadius: "8px", justifyContent: "center", alignItems: "center"}}>
                    <span className="fontello" style={{marginTop: "-6px"}}>
                        <Icon
                        name="q-alert-octagon"
                        size={18}
                        height={22}
                        color="#FFFFFF"
                        strokeOptions={{
                            stroke: "#fff",
                            width: "1.5",
                            lineCap: "round",
                            lineJoin: "round",
                        }}
                        />
                    </span>
                </div>
            </div>
            <div style={{display: "flex", flexDirection: "column", textAlign: "left",}}>
                <div className="blockTHeader">Error</div>
                <div> {errorMessage} </div>
            </div>
        </div>
        {errorSolutions.length > 0 && (
            <div style={{ display: "flex", flexDirection: "row", marginTop: 16, marginLeft: '6%'}}>
                <div style={{ display: "flex", flexDirection: "column", textAlign: "left", }}>
                    <div className="blockTHeader">Solution(s)</div>
                    <ul>
                        {errorSolutions.map((solution, index) => (
                            <li key={`twilio_error_solution_key_${index}`}>{solution}</li>
                        ))}
                    </ul>
                </div>
            </div>
        )}
        <div style={{ width: "120px", marginTop: 16 }}>
            <OutlineButton
                buttonLabel={'Done'}
                clickHandler={_ => handleClose()}
            />
        </div>
    </div>
  )
}

export const TwilioCallErrorModal = ({ handleClose, errorMessage, errorSolutions = [] }) => {
  return (
    <div className="tMobileErrorModal">
      <div className="tMobileErrorDialog">
        <div style={{ display: "flex", flexDirection: "row", columnGap: "18px" }}>
            <div>
                <div style={{ height: "40px", width: "40px", display: "flex", backgroundColor: "#F95951", borderRadius: "8px", justifyContent: "center", alignItems: "center"}}>
                    <span className="fontello" style={{marginTop: "-6px"}}>
                        <Icon
                        name="q-alert-octagon"
                        size={18}
                        height={22}
                        color="#FFFFFF"
                        strokeOptions={{
                            stroke: "#fff",
                            width: "1.5",
                            lineCap: "round",
                            lineJoin: "round",
                        }}
                        />
                    </span>
                </div>
            </div>
            <div style={{display: "flex", flexDirection: "column", textAlign: "left",}}>
                <div className="blockTHeader">Error</div>
                <div> {errorMessage} </div>
            </div>
        </div>
        {errorSolutions.length > 0 && (
            <div style={{ display: "flex", flexDirection: "row", marginTop: 16, marginLeft: '6%' }}>
                <div style={{ display: "flex", flexDirection: "column", textAlign: "left", }}>
                    <div className="blockTHeader">Solution(s)</div>
                    <ul>
                        {errorSolutions.map((solution, index) => (
                            <li key={`twilio_error_modal_solution_key_${index}`}>{solution}</li>
                        ))}
                    </ul>
                </div>
            </div>
        )}
        <div style={{ width: "120px", marginTop: 16 }}>
            <BrandedButton
                buttonLabel={'Done'}
                clickHandler={_ => handleClose()}
                buttonType={brandedButtonTypes.SECONDARY}
            />
        </div>
      </div>
    </div>
  );
};
